import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Button, Spinner, Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getCaseDetailsListById, saveCaseInitiatedData, saveMotorCaseInitiatedData } from "../../redux/actions/CaseDetailsActions";
import FormInput from "../FormInput";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import { CLAIM_TYPE_CATEGORY } from "../../constants/claimTypeCategory";
import MotorCaseInitiatedAddFields, {
  buildMotorOdAddPayload,
} from "./case-initiated/MotorCaseInitiatedAddFields";
import { getMasterInsuranceList, getAllInsuranceManagerWiseList, getMasterHospitalList, getMasterClaimTypeList, getMasterUsertypeUserWiseList, getMasterUserUserTypeWiseList, getAllStateList, getAllCityStateWiseList, getMasterBackendOfficerList, getMasterCaseManagerList, getMasterInsuranceTpaList } from "../../redux/actions/MasterActions";
import AddInsuranceManagerManager from "../../Components/FormComponent/AddInsuranceManager";
import AddHospital from "../../Components/FormComponent/AddHospital";
import AddTypeOfClaim from "../../Components/FormComponent/AddTypeOfClaim";
import Preloader from "../Preloader";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import '../../styles/common.css'

const API_KEY = "AIzaSyD5L3M2Nl4wn3coWVJlI06RjT50l44FMu8";

const AddCaseInitiated = ({ show, onHide, editId, claimCategory }) => {
  const { t } = useTranslation();
  const isMotor = claimCategory === CLAIM_TYPE_CATEGORY.MOTOR;
  const [showModel, setShowModel] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [placeData, setPlaceData] = useState({});
  const [formData, setFormData] = useState({});
  const [kycType, setKycType] = useState(null);
  const [kycNumber, setKycNumber] = useState("");
  const [kycFormatNote, setKycFormatNote] = useState("");
  const [kycValidationError, setKycValidationError] = useState("");
  const [kycEntries, setKycEntries] = useState([]);
  const [insuranceId, setInsuranceId] = useState(null);
  const [caseManagerUserTypeId, setCaseManagerUserTypeId] = useState(null);

  const [showInsuranceManagerModel, setShowInsuranceManagerModel] = useState(false);
  const hideInsuranceManagerModel = () => {
    setShowInsuranceManagerModel(false);
    dispatch(getAllInsuranceManagerWiseList(auth.token, insuranceId));
  };

  const [showHospitalModel, setShowHospitalModel] = useState(false);
  const hideHospitalModel = () => {
    setShowHospitalModel(false);
    dispatch(getMasterHospitalList(auth.token));
  };

  const [showTypeOfClaimModel, setShowTypeOfClaimModel] = useState(false);
  const hideTypeOfClaimModel = () => {
    setShowTypeOfClaimModel(false);
    dispatch(getMasterClaimTypeList(auth.token, claimCategory));
  };

  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    caseDetailsReducer: {
      caseDetailsLists,
      loadingCaseDetails,
      errorsCaseDetails,
      changedCaseDetailsStatus,
      loadingMotorCaseDetails,
      errorsMotorCaseDetails,
      changedMotorCaseDetailsStatus,
    },
    masterReducer: {
      masterInsuranceList,
      masterInsuranceTpaList,
      masterInsuranceManagerWiseList,
      masterHospitalList,
      masterClaimTypeList,
      masterUsertypeLists,
      masterCaseManagerLists,
      masterStateLists,
      masterCityStateWiseLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  const activeCaseErrors = isMotor ? errorsMotorCaseDetails : errorsCaseDetails;
  const activeChangedStatus = isMotor ? changedMotorCaseDetailsStatus : changedCaseDetailsStatus;
  const activeCaseLoading = isMotor ? loadingMotorCaseDetails : loadingCaseDetails;
  const resetCaseDetailsStatusType = isMotor
    ? "RESET_MOTOR_CASE_DETAILS_STATUS"
    : "RESET_DELETE_CASE_DETAILS_STATUS";

  useEffect(() => {
    if (show && auth?.token) {
      dispatch(getMasterInsuranceList(auth.token));
      dispatch(getMasterInsuranceTpaList(auth.token));
      dispatch(getMasterCaseManagerList(auth?.token));
      dispatch(getAllStateList(auth.token));
    }
  }, [show, auth?.token, dispatch]);

  useEffect(() => {
    if (show && auth?.token && insuranceId) {
      dispatch(getAllInsuranceManagerWiseList(auth.token, insuranceId));
    }
  }, [show, auth?.token, insuranceId, dispatch]);

  useEffect(() => {
    if (show && auth?.token && !isMotor) {
      dispatch(getMasterHospitalList(auth.token));
    }
  }, [show, auth?.token, dispatch, isMotor]);

  useEffect(() => {
    if (show && auth?.token) {
      dispatch(getMasterClaimTypeList(auth.token, claimCategory));
    }
  }, [show, auth?.token, dispatch, claimCategory]);

  // Load cities for selected state
  useEffect(() => {
    if (show && auth?.token && stateId) {
      dispatch(getAllCityStateWiseList(auth.token, stateId));
    }
  }, [show, auth?.token, stateId, dispatch]);

  const [validated, setValidated] = useState(false);
  

  useEffect(() => {
    if (show) {
      setFormData({})
      setKycType(null);
      setKycNumber("");
      setKycFormatNote("");
      setKycValidationError("");
      setKycEntries([]);
      if(editId) {
        dispatch(getCaseDetailsListById(auth?.token, editId));
      }
    }
  }, [show, auth, editId, dispatch]);

  useEffect(() => {
    if (show) {
      dispatch({ type: resetCaseDetailsStatusType });
      setValidated(false);
    }
  }, [show, dispatch, resetCaseDetailsStatusType]);
  

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    setValidated(true);

    const basePayload = {
      ...formData,
      tpa_case: formData?.tpa_case,
      tpa_id: formData?.tpa_case === "Yes" ? (formData?.tpa_id ?? null) : null,
      claim_type_category: claimCategory || CLAIM_TYPE_CATEGORY.HEALTH,
    };

    if (isMotor) {
      dispatch(
        saveMotorCaseInitiatedData(auth?.token, {
          ...basePayload,
          motor_od_details: buildMotorOdAddPayload(formData),
        })
      );
      return;
    }

    dispatch(
      saveCaseInitiatedData(auth?.token, {
        ...basePayload,
        patient_kyc_details: kycEntries,
      })
    );
  };

  
  useEffect(() => {
    if(editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) {
      setFormData({
      });
    }
  }, [caseDetailsLists]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0 && errors?.status === 401) {
      dispatch(logout());
      toast.error(errors?.data?.message);
      onHide(); // Close modal on logout
    }
  }, [errors, dispatch, onHide]);


  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const selectMobileHandler = (e) => {
    const { value, name } = e.target;
    if (/^\d{0,10}$/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const selectHandler2 = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));
  };

  const inputDateHandler = (name,value) => {
    //const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const inputTimeHandler = (name, value) => {
    if (!value) {
      setFormData((prev) => ({ ...prev, [name]: null }));
      return;
    }
    const hours = String(value.getHours()).padStart(2, "0");
    const minutes = String(value.getMinutes()).padStart(2, "0");
    setFormData((prev) => ({ ...prev, [name]: `${hours}:${minutes}:00` }));
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: activeCaseErrors?.data?.vehicle_model ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: activeCaseErrors?.data?.vehicle_model ? 'red' : base.borderColor,
      }
    }),
  };

  const kycTypeOptions = [
    { label: "Aadhar Card", value: "Aadhar Card" },
    { label: "PAN Card", value: "PAN Card" },
    { label: "Voter ID", value: "Voter ID" },
    { label: "Driving License", value: "Driving License" },
  ];

  const kycDocumentConfigs = {
    "Aadhar Card": {
      pattern: /^\d{12}$/,
      format: "12 digits (e.g., 123456789012)",
    },
    "PAN Card": {
      pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
      format: "ABCDE1234F format",
    },
    "Voter ID": {
      pattern: /^[A-Z]{3}[0-9]{7}$/,
      format: "3 letters + 7 digits (e.g., ABC1234567)",
    },
    "Driving License": {
      pattern: /^[A-Z]{2}[0-9]{13}$/,
      format: "2 letters + 13 digits (e.g., MH0123456789012)",
    },
  };

  const getKycPlaceholder = (type) => {
    if (!type) return t("Enter KYC Number");
    if (type === "Aadhar Card") return t("Enter Aadhar Number");
    if (type === "PAN Card") return t("Enter PAN Number");
    if (type === "Voter ID") return t("Enter Voter ID Number");
    if (type === "Driving License") return t("Enter Driving License Number");
    return t("Enter KYC Number");
  };

  const normalizeKycInput = (type, rawValue) => {
    const value = String(rawValue ?? "");
    const trimmed = value.trim();
    if (!type) return trimmed;

    if (type === "PAN Card" || type === "Voter ID" || type === "Driving License") {
      return trimmed.toUpperCase();
    }
    return trimmed;
  };

  const validateKycNumber = (type, rawValue) => {
    if (!type) return "";
    const config = kycDocumentConfigs[type];
    if (!config) return "";

    const normalized = normalizeKycInput(type, rawValue);
    if (!normalized.length) return "";

    const isValid = config.pattern.test(normalized);
    if (isValid) return "";
    return `Please enter valid ${type} number in correct format.`;
  };

  const handleSaveKycRow = () => {
    if (!kycType) {
      toast.error(t("Please select KYC Type"));
      return;
    }

    const normalized = normalizeKycInput(kycType, kycNumber);
    if (!normalized.length) {
      toast.error(t("Please enter KYC Number"));
      return;
    }

    const validationMessage = validateKycNumber(kycType, normalized);
    if (validationMessage) {
      toast.error(validationMessage);
      return;
    }

    if (kycValidationError) {
      toast.error(kycValidationError);
      return;
    }

    setKycEntries((prev) => [
      ...prev,
      {
        kyc_type: kycType,
        kyc_number: normalized,
      },
    ]);

    setKycType(null);
    setKycNumber("");
    setKycFormatNote("");
    setKycValidationError("");
  };

  useEffect(() => {
    if (activeChangedStatus?.success) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: activeChangedStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      setFormData({});
      setKycType(null);
      setKycNumber("");
      setKycFormatNote("");
      setKycValidationError("");
      setKycEntries([]);
      setInsuranceId(null);
      setCaseManagerUserTypeId(null);
      setValidated(false);
      dispatch({ type: resetCaseDetailsStatusType });
      onHide();
    }
  }, [activeChangedStatus, dispatch, onHide, resetCaseDetailsStatusType]);

  useEffect(() => {
    if (activeCaseErrors && Object.keys(activeCaseErrors).length > 0) {
      if (activeCaseErrors?.status !== 401) {
      }
    }
  }, [activeCaseErrors]);


  return (
    <Modal show={show} onHide={onHide} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{(editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) ? t("Update Case Initiated") : t("Add Case Initiated")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {activeCaseErrors?.data?.message && (
          <div className="alert alert-danger" role="alert">
            {activeCaseErrors?.data?.message}
          </div>
        )}

        <Row>
          <Col lg={4}>
            <FormInput
              label={t("Claim Number")}
              type="text"
              placeholder={t("Enter Claim Number")}
              errors={activeCaseErrors?.data}
              value={formData.claim_number}
              name="claim_number"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={4}>
            <FormInput
              label={t("Policy Number")}
              type="text"
              placeholder={t("Enter Policy Number")}
              errors={activeCaseErrors?.data}
              value={formData.policy_number}
              name="policy_number"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label className="d-block">{t("TPA Case")}</Form.Label>
              <div className="d-flex gap-2 align-items-center" style={{ minHeight: 38 }}>
                <Form.Check
                  type="radio"
                  id="tpa_case_yes"
                  name="tpa_case"
                  label={t("Yes")}
                  checked={formData?.tpa_case === "Yes"}
                  onChange={() => {
                    // reset dependent selections when toggling to Yes
                    setFormData((prev) => ({
                      ...prev,
                      tpa_case: "Yes",
                      tpa_id: null,
                      insurance_id: null,
                      manager_id: null,
                    }));
                    setInsuranceId(null);
                  }}
                />
                <Form.Check
                  type="radio"
                  id="tpa_case_no"
                  name="tpa_case"
                  label={t("No")}
                  checked={formData?.tpa_case === "No"}
                  onChange={() => {
                    // revert to existing flow when No
                    setFormData((prev) => ({
                      ...prev,
                      tpa_case: "No",
                      tpa_id: null,
                    }));
                  }}
                />
              </div>
              {activeCaseErrors?.data?.tpa_case && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{activeCaseErrors?.data?.tpa_case}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          {formData?.tpa_case === "Yes" && (
            <Col lg={4}>
              <Form.Group className="mb-3">
                <Form.Label>{t("TPA")}</Form.Label>
                <Select
                  options={Array.isArray(masterInsuranceTpaList) ? masterInsuranceTpaList : []}
                  values={
                    Array.isArray(masterInsuranceTpaList)
                      ? masterInsuranceTpaList?.filter((x) => x?.id === formData?.tpa_id)
                      : []
                  }
                  name="tpa_id"
                  labelField={"name"}
                  valueField={"id"}
                  searchBy={"name"}
                  placeholder={t("Select TPA")}
                  loading={loadingMaster}
                  onChange={(selectedData) => {
                    selectHandler2(selectedData[0]?.id, "tpa_id");
                    // when TPA changes, reset insurance/manager so user selects insurance after TPA
                    setFormData((prev) => ({
                      ...prev,
                      insurance_id: null,
                      manager_id: null,
                    }));
                    setInsuranceId(null);
                  }}
                  styles={customSelectStyles}
                />
                {activeCaseErrors?.data?.tpa_id && (
                  <div className="invalid-feedback d-block">
                    <p className="text-danger">{activeCaseErrors?.data?.tpa_id}</p>
                  </div>
                )}
              </Form.Group>
            </Col>
          )}

          <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Insurance Company")}</Form.Label>
              <Select
                options={masterInsuranceList}
                values={masterInsuranceList?.filter(insurance => insurance.id === formData.insurance_id)}
                name="insurance_id"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Insurance Company")}
                loading={loadingMaster}
                disabled={formData?.tpa_case === "Yes" && !formData?.tpa_id}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "insurance_id")
                  setInsuranceId(selectedData[0]?.id);
                }}
                styles={customSelectStyles}
              />
              
              {activeCaseErrors?.data?.insurance_id && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{activeCaseErrors?.data?.insurance_id}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          {insuranceId && (
            <>
              <Col lg={4}>
                <Form.Group className="mb-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <Form.Label>{t("Client Company Case Manager")}</Form.Label>
                    <button 
                      className="btn btn-link p-0 text-decoration-none" 
                      onClick={() => setShowInsuranceManagerModel(true)}
                      type="button"
                    >
                      {t("Add New Manager")}
                    </button>
                  </div>
                  <Select
                    options={Array.isArray(masterInsuranceManagerWiseList) ? masterInsuranceManagerWiseList : []}
                    values={Array.isArray(masterInsuranceManagerWiseList) ? masterInsuranceManagerWiseList.filter(manager => manager.id === formData.manager_id) : []}
                    name="manager_id"
                    labelField={"name"}
                    valueField={"id"}
                    searchBy={"name"}
                    placeholder={t("Select Manager")}
                    loading={loadingMaster}
                    onChange={(selectedData) => {
                      selectHandler2(selectedData[0]?.id, "manager_id");
                    }}
                    styles={customSelectStyles}
                  />
                  {activeCaseErrors?.data?.manager_id && (
                    <div className="invalid-feedback d-block">
                      <p className="text-danger">{activeCaseErrors?.data?.manager_id}</p>
                    </div>
                  )}
                </Form.Group>
              </Col>
            </>
          )}

          {!isMotor && (
          <Col lg={4}>
            <Form.Group className="mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <Form.Label>{t("Hospital Name")}</Form.Label>
                <button 
                  className="btn btn-link p-0 text-decoration-none" 
                  onClick={() => setShowHospitalModel(true)}
                  type="button"
                >
                  {t("Add New Hospital")}
                </button>
              </div>
              <Select
                options={masterHospitalList}
                values={masterHospitalList?.filter(hospital => hospital.id === formData.hospital_id)}
                name="hospital_id"
                labelField={"hospital_name"}
                valueField={"id"}
                searchBy={"hospital_name"}
                placeholder={t("Select Hospital Name")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "hospital_id")
                }}
                styles={customSelectStyles}
              />
              
              {activeCaseErrors?.data?.hospital_id && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{activeCaseErrors?.data?.hospital_id}</p>
                </div>
              )}
            </Form.Group>
          </Col>
          )}

          <Col lg={4}>
            <Form.Group className="mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <Form.Label>{t("Claim Type")}</Form.Label>
                <button 
                  className="btn btn-link p-0 text-decoration-none" 
                  onClick={() => setShowTypeOfClaimModel(true)}
                  type="button"
                >
                  {t("Add New Claim Type")}
                </button>
              </div>
              <Select
                options={masterClaimTypeList}
                values={masterClaimTypeList?.filter(claim => claim.id === formData.claim_type)}
                name="claim_type"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                placeholder={t("Select Claim Type")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "claim_type")
                }}
                styles={customSelectStyles}
              />
              
              {activeCaseErrors?.data?.claim_type && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{activeCaseErrors?.data?.claim_type}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Case Open Date Time")}</Form.Label>
              <DatePicker
                selected={formData.case_open_date}
                onChange={(value) => inputDateHandler('case_open_date', value)}
                dateFormat="yyyy-MM-dd HH:mm:ss"
                className="form-control"
                withPortal
                showYearDropdown
                scrollableYearDropdown
                showTimeSelect
                timeIntervals={15}
                timeCaption="Time"
                todayButton="Today"
                isClearable
              />

              {activeCaseErrors?.data?.case_open_date && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">{activeCaseErrors?.data?.case_open_date}</p>
                </div>
              )}
            </Form.Group>
          </Col>

          {formData.case_open_date && (<>
            <Col lg={4}>
              <Form.Group className="mb-3">
                <Form.Label>{t("Case Close Date")}</Form.Label>
                <DatePicker
                  selected={formData.case_close_date}
                  onChange={(value) => inputDateHandler('case_close_date', value)}
                  dateFormat="yyyy-MM-dd HH:mm:ss"
                  className="form-control"
                  withPortal
                  showYearDropdown
                  scrollableYearDropdown
                  showTimeSelect
                  timeIntervals={15}
                  timeCaption="Time"
                  todayButton="Today"
                  isClearable
                />

                {activeCaseErrors?.data?.case_close_date && (
                  <div className="invalid-feedback d-block">
                    <p className="text-danger">{activeCaseErrors?.data?.case_close_date}</p>
                  </div>
                )}
              </Form.Group>
            </Col>
          </>)}

          {/* <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label>{t("User Type")}</Form.Label>
              <Select
                options={masterUsertypeLists}
                values={masterUsertypeLists?.filter(
                  (usertype) => usertype.id === caseManagerUserTypeId
                )}
                name="caseManagerUserTypeId"
                labelField={"name"}
                valueField={"id"}
                searchBy={"name"}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  const selectedId = selectedData[0]?.id;
                  setCaseManagerUserTypeId(selectedId);
                  // reset selected manager when type changes
                  setFormData((prev) => ({ ...prev, caseManagerId: null }));
                }}
                styles={customSelectStyles}
              />
            </Form.Group>
          </Col> */}

          <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Internal Case Manager")}</Form.Label>
                <Select
                    options={masterCaseManagerLists?.map(user => ({
                      ...user,
                      customLabel: `${user.name} ( ${user?.adminUserType?.name} ) - ${user?.citiesAdminUsers?.city_name}, ${user?.citiesAdminUsers?.cities_state?.state_name} | Total Cases: ${user?.totalCaseCount} | Doctor Report Cases: ${user?.doctorReportCaseCount} | Att: ${user?.todayAttendance}`
                    }))}
                    values={masterCaseManagerLists?.filter(user => user?.id === formData?.caseManagerId)?.map(user => ({
                      ...user,
                      customLabel: `${user.name} ( ${user?.adminUserType?.name} ) - ${user?.citiesAdminUsers?.city_name}, ${user?.citiesAdminUsers?.cities_state?.state_name} | Total Cases: ${user?.totalCaseCount} | Doctor Report Cases: ${user?.doctorReportCaseCount} | Att: ${user?.todayAttendance}`
                    }))}
                    name="caseManagerId"
                    labelField="customLabel"
                    valueField="id"
                    searchBy="name"
                    placeholder={t("Select Investigator")}
                    loading={loadingMaster}
                    onChange={(selectedData) => {
                      if (selectedData.length > 0) {
                        selectHandler2(selectedData[0]?.id, "caseManagerId");
                      }
                    }}
                    itemRenderer={({ item, itemIndex, props, state, methods }) => (
                      <div 
                        onClick={() => methods.addItem(item)}
                        style={{
                          padding: '10px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #eee',
                          backgroundColor: state.values.find(val => val.id === item.id) ? '#e3f2fd' : 'white'
                        }}
                      >
                        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                          {item.name} <span style={{ color: '#666', fontSize: '0.9em' }}>({item?.adminUserType?.name})</span>
                        </div>
                        <div style={{ fontSize: '0.85em', color: '#555', marginBottom: '3px' }}>
                          {item?.citiesAdminUsers?.city_name}, {item?.citiesAdminUsers?.cities_state?.state_name}
                        </div>
                        <div style={{ display: 'flex', gap: '15px', fontSize: '0.8em', marginTop: '5px' }}>
                          <span style={{ color: '#FF9800' }}>
                            <strong>Total Cases:</strong> {item?.totalCaseCount}
                          </span>
                          <span style={{ color: '#FF9800' }}>
                            <strong>Doctor Report Cases:</strong> {item?.doctorReportCaseCount}
                          </span>
                          <span style={{ 
                            color: item?.todayAttendance === 'Present' ? '#4CAF50' : item?.todayAttendance === 'Not Working' ? '#F44336' : '#666',
                            fontWeight: '500'
                          }}>
                            <strong>Att:</strong> {item?.todayAttendance}
                          </span>
                        </div>
                      </div>
                    )}
                    styles={customSelectStyles}
                  />
              {/* <Select
                options={masterCaseManagerLists.map((user) => ({
                  ...user,
                  label: `${user.name}`,
                }))}
                values={masterCaseManagerLists
                  .map((user) => ({
                    ...user,
                    label: `${user.name}`,
                  }))
                  .filter((user) => user.id === formData.caseManagerId)}
                name="caseManagerId"
                labelField="label"
                valueField="id"
                searchBy="label"
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.id, "caseManagerId");
                }}
                styles={customSelectStyles}
              /> */}

              {activeCaseErrors?.data?.caseManagerId && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {activeCaseErrors?.data?.caseManagerId}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        {isMotor ? (
          <MotorCaseInitiatedAddFields
            t={t}
            formData={formData}
            inputHandler={inputHandler}
            inputDateHandler={inputDateHandler}
            inputTimeHandler={inputTimeHandler}
            selectMobileHandler={selectMobileHandler}
            errors={activeCaseErrors?.data}
          />
        ) : (
        <>
        {/* Patient & Primary Insured basic details (after Case Manager, before First Trigger) */}
        <Row>
          <h3 style={{ color: '#d10b0b' }}>Patient Details -: </h3>
          <Col lg={4}>
            <FormInput
              label={t("Patient Name")}
              type="text"
              placeholder={t("Enter Patient Name")}
              errors={activeCaseErrors?.data}
              value={formData.patient_name}
              name="patient_name"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={4}>
            <FormInput
              label={t("Patient Phone Number")}
              type="text"
              placeholder={t("Enter Patient Phone Number")}
              errors={activeCaseErrors?.data}
              value={formData.patient_phone}
              name="patient_phone"
              onChange={selectMobileHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={4}>
            <FormInput
              label={t("Patient Address")}
              type="text"
              placeholder={t("Enter Patient Address")}
              errors={activeCaseErrors?.data}
              value={formData.patient_address}
              name="patient_address"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Patient State")}</Form.Label>
              <Select
                options={masterStateLists}
                values={masterStateLists?.filter(
                  (state) => state?.state_code === formData?.patient_state
                )}
                name="patient_state"
                labelField={"state_name"}
                valueField={"state_code"}
                searchBy={"state_name"}
                placeholder={t("Select Patient State")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.state_code, "patient_state");
                  setStateId(selectedData[0]?.state_code);
                }}
                styles={customSelectStyles}
              />

              {activeCaseErrors?.data?.patient_state && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {activeCaseErrors?.data?.patient_state}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Patient City")}</Form.Label>
              <Select
                options={masterCityStateWiseLists}
                values={masterCityStateWiseLists?.filter(
                  (city) => city?.city_code === formData?.patient_city
                )}
                name="patient_city"
                labelField={"city_name"}
                valueField={"city_code"}
                searchBy={"city_name"}
                placeholder={t("Select Patient City")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.city_code, "patient_city");
                }}
                styles={customSelectStyles}
              />

              {activeCaseErrors?.data?.patient_city && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {activeCaseErrors?.data?.patient_city}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>
<Row>
          <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label>{t("KYC Type")}</Form.Label>
              <Select
                options={kycTypeOptions}
                values={kycType ? kycTypeOptions.filter((x) => x.value === kycType) : []}
                name="kyc_type"
                labelField={"label"}
                valueField={"value"}
                searchBy={"label"}
                placeholder={t("Select KYC Type")}
                onChange={(selectedData) => {
                  const nextType = selectedData[0]?.value;
                  setKycType(nextType);
                  setKycNumber("");
                  setKycValidationError("");
                  setKycFormatNote(kycDocumentConfigs[nextType]?.format || "");
                }}
                styles={customSelectStyles}
              />
            </Form.Group>
            </Col>
            <Col lg={4}>
            {kycType && (
              <div className="mb-3">
                <div className="d-flex gap-2 align-items-end">
                  <div className="flex-grow-1">
                    <Form.Label className="d-block">{t("KYC Number")}</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={getKycPlaceholder(kycType)}
                      value={kycNumber}
                      isInvalid={!!kycValidationError}
                      onChange={(e) => {
                        const normalized = normalizeKycInput(kycType, e.target.value);
                        setKycNumber(normalized);
                        setKycValidationError(validateKycNumber(kycType, normalized));
                      }}
                    />
                  </div>
                  <Button type="button" size="md" onClick={handleSaveKycRow}>
                    {t("Save")}
                  </Button>
                </div>
                {(kycFormatNote || kycValidationError) && (
                  <div className="mt-2">
                    {kycFormatNote && (
                      <div className="text-muted" style={{ fontSize: 13 }}>
                        {kycFormatNote}
                      </div>
                    )}
                    {kycValidationError && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{kycValidationError}</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            </Col>
            <Col lg={4}>
            {kycEntries.length > 0 && (
              <div className="mt-2">
                <table className="table table-bordered table-sm mb-0">
                  <thead>
                    <tr>
                      <th>{t("Sr. No.")}</th>
                      <th>{t("KYC Type")}</th>
                      <th>{t("KYC Number")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {kycEntries.map((row, idx) => (
                      <tr key={`${row?.kyc_type ?? "kyc"}-${idx}`}>
                        <td>{idx + 1}</td>
                        <td>{row?.kyc_type}</td>
                        <td>{row?.kyc_number}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Col>
          </Row>
        </Row>

        <Row>
          <Col lg={12}>
            <Form.Check
              type="checkbox"
              name="is_patient_primary_same"
              containerClass={"mb-3"}
              label={t("Click This If Patient & Insured Member Are Same")}
              checked={formData?.is_patient_primary_same === true}
              onChange={(e) => {
                const isChecked = e.target.checked;
                inputHandler({
                  target: {
                    name: "is_patient_primary_same",
                    value: isChecked,
                  },
                });

                setFormData((prevData) => {
                  const updatedFormData = isChecked
                    ? {
                        ...prevData,
                        is_patient_primary_same: true,
                        primary_name: prevData.patient_name || "",
                        primary_phone: prevData.patient_phone || "",
                        primary_address: prevData.patient_address || "",
                        primary_state: prevData.patient_state || null,
                        primary_city: prevData.patient_city || null,
                      }
                    : {
                        ...prevData,
                        is_patient_primary_same: false,
                        primary_name: "",
                        primary_phone: "",
                        primary_address: "",
                        primary_state: null,
                        primary_city: null,
                      };

                  return updatedFormData;
                });
              }}
            />
          </Col>
        </Row>

        <Row>
          <h3 style={{ color: '#d10b0b' }}>Primary Insured Details -: </h3>
          <Col lg={4}>
            <FormInput
              label={t("Primary Insured Name")}
              type="text"
              placeholder={t("Enter Primary Insured Name")}
              errors={activeCaseErrors?.data}
              value={formData.primary_name}
              name="primary_name"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={4}>
            <FormInput
              label={t("Primary Insured Phone Number")}
              type="text"
              placeholder={t("Enter Primary Insured Phone Number")}
              errors={activeCaseErrors?.data}
              value={formData.primary_phone}
              name="primary_phone"
              onChange={selectMobileHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={4}>
            <FormInput
              label={t("Primary Insured Address")}
              type="text"
              placeholder={t("Enter Primary Insured Address")}
              errors={activeCaseErrors?.data}
              value={formData.primary_address}
              name="primary_address"
              onChange={inputHandler}
              containerClass={"mb-3"}
            />
          </Col>

          <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Primary Insured State")}</Form.Label>
              <Select
                options={masterStateLists}
                values={masterStateLists?.filter(
                  (state) => state?.state_code === formData?.primary_state
                )}
                name="primary_state"
                labelField={"state_name"}
                valueField={"state_code"}
                searchBy={"state_name"}
                placeholder={t("Select Primary Insured State")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.state_code, "primary_state");
                  setStateId(selectedData[0]?.state_code);
                }}
                styles={customSelectStyles}
              />

              {activeCaseErrors?.data?.primary_state && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {activeCaseErrors?.data?.primary_state}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>

          <Col lg={4}>
            <Form.Group className="mb-3">
              <Form.Label>{t("Primary Insured City")}</Form.Label>
              <Select
                options={masterCityStateWiseLists}
                values={masterCityStateWiseLists?.filter(
                  (city) => city?.city_code === formData?.primary_city
                )}
                name="primary_city"
                labelField={"city_name"}
                valueField={"city_code"}
                searchBy={"city_name"}
                placeholder={t("Select Primary Insured City")}
                loading={loadingMaster}
                onChange={(selectedData) => {
                  selectHandler2(selectedData[0]?.city_code, "primary_city");
                }}
                styles={customSelectStyles}
              />

              {activeCaseErrors?.data?.primary_city && (
                <div className="invalid-feedback d-block">
                  <p className="text-danger">
                    {activeCaseErrors?.data?.primary_city}
                  </p>
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>
        </>
        )}

        <Row>
          <Col lg={6}>
            <FormInput
              label={t("First Trigger")}
              type="textarea"
              placeholder={t("Enter First Trigger")}
              errors={activeCaseErrors?.data}
              value={formData.first_trigger}
              name="first_trigger"
              onChange={inputHandler}
              containerClass={"mb-3"}
              rows={6}
            />
          </Col>

          <Col lg={6}>
            <FormInput
              label={t("Diagnosis")}
              type="textarea"
              placeholder={t("Enter Diagnosis")}
              errors={activeCaseErrors?.data}
              value={formData.diagnosis}
              name="diagnosis"
              onChange={inputHandler}
              containerClass={"mb-3"}
              rows={6}
            />
          </Col>
        </Row>
        <div className="d-flex justify-content-center">
          {activeCaseLoading ? 
            <Button color="primary" disabled>
              <Spinner animation="border" size="sm" />
              {t("Please wait ...")}
            </Button>
          :
            <Button type="button" onClick={(e) => handleSubmit(e)} disabled={activeCaseLoading}>
            {(editId && caseDetailsLists && Object.keys(caseDetailsLists).length > 0) ? t("Update") : t("Add")}
            </Button>
          }
        </div>
      </Modal.Body>
      <AddInsuranceManagerManager show={showInsuranceManagerModel} onHide={() => hideInsuranceManagerModel()}  />
      <AddHospital show={showHospitalModel} onHide={() => hideHospitalModel()}  />
      <AddTypeOfClaim show={showTypeOfClaimModel} onHide={() => hideTypeOfClaimModel()}  />
      {activeCaseLoading && <Preloader />}
    </Modal>
  );
};

export default AddCaseInitiated;
